Monitoring.Views ||= {}

class Monitoring.Views.SocialContentHistoryView extends Backbone.View
  templateDescription: JST['backbone/templates/monitoring/social_contents/social_content_history_description']
  template: JST['backbone/templates/monitoring/social_contents/social_content_history']

  initialize: (@options = {}) ->
    # just set @options

  show: ->
    @$el.modal()
    @$el.on('hidden', =>
      $('.modal-backdrop').remove()
      @options.onHidden?()
      true
    )
    @$el.find('.nano-content').html('').addClass('processing')
    $.ajax
      type: 'POST'
      url: '/social_content/history'
      data:
        content_id: @model.get('id')
      success: (response) =>
        return unless response.events
        @events = response.events
        @addHistory(@events)

  addHistory: (events) =>
    @$el.find('.description').html @templateDescription
      self: this
    @$el.find('.nano-content').html('').removeClass('processing')
    @_renderEvent event for event in @events
    @_refreshScrollerWhenReady()

  _renderEvent: (event) ->
    @$el.find('.nano-content').append @template
      event: event

  _refreshScrollerWhenReady: ->
    return setInterval(@_refreshScrollerWhenReady(), 100) unless @_scrollableAreaReady()
    @$el.find('#nano-history').nanoScroller().nanoScroller
      scroll: 'bottom'

  _scrollableAreaReady: ->
    @$el.find('#nano-history')[0].scrollHeight > 0
